<!-- BEGIN: Horizontal Menu -->
<div class="{{getCssClass()}}" id="kt_header_menu" #kt_header_menu>

  <button class="kt-aside-header-menu-mobile-close  kt-aside-header-menu-mobile-close--skin-light"
    id="kt_aside_header_menu_mobile_close_btn">

    @if (!appSession.tenant || !appSession.tenant.HasLogo) {
      <img src="/assets/common/images/sidebar-icons/close.svg"
        alt="logo" height="14" />
    }

  </button>

  <ul class="kt-menu__nav kt-menu__nav--submenu-arrow">
    @for (item of menu.items; track item) {
      @if (item.name) {
        <ng-container [ngTemplateOutlet]="kt_menu" [ngTemplateOutletContext]="{ item: item, depth: 0 }">
        </ng-container>
      }
    }
  </ul>
</div>
<!-- END: Horizontal Menu -->

<ng-template #kt_menu let-item="item" let-parentItem="parentItem" let-depth="depth">
  @if (showMenuItem(item)) {
    <li [attr.kt-menu-submenu-toggle]="getItemAttrSubmenuToggle(item, parentItem, depth)"
      class="{{ getItemCssClasses(item, parentItem, depth) }}"
      routerLinkActive="kt-menu__item--active"><!-- NOSONAR -->
      <!-- if item has submenu -->
      @if (item.items.length || (isTabMenuUsed && !parentItem && !item.items.length)) {
        <a href="javascript:;" class="{{ getAnchorItemCssClasses(item, parentItem) }} d-flex" (click)="goTo(item)">
          <div class="circle-rectangle d-flex justify-content-center align-items-center">
            <div class="oval"></div>
            <ng-container [ngTemplateOutlet]="kt_menu_item_inner"
              [ngTemplateOutletContext]="{ item: item, parentItem: parentItem, depth: (depth + 1) }">
            </ng-container>
          </div>
          <!-- arrow icons -->
          <!-- <i *ngIf="item.items.length && !parentItem" class="kt-menu__hor-arrow la la-angle-down"></i>
          <i *ngIf="item.items.length && !parentItem" class="kt-menu__ver-arrow la la-angle-right"></i> -->
          <!-- else arrow icons -->
          <!-- <i *ngIf="item.items.length && parentItem" class="kt-menu__hor-arrow la la-angle-right"></i>
          <i *ngIf="item.items.length && parentItem" class="kt-menu__ver-arrow la la-angle-right"></i> -->
        </a>
      }
      <!-- if item hasn't sumbenu -->
      @if (!item.items.length && !(isTabMenuUsed && !parentItem && !item.items.length) && !isDesktop) {
        @if (!item.external) {
          <a [routerLink]="item.route" [queryParams]="item.parameters" class="kt-menu__link">
            <ng-container [ngTemplateOutlet]="kt_menu_item_inner"
              [ngTemplateOutletContext]="{ item: item, parentItem: parentItem, depth: (depth + 1) }">
            </ng-container>
          </a>
        }
        @if (item.external) {
          <a [attr.href]="[item.route]" target="_blank" class="kt-menu__link">
            <ng-container [ngTemplateOutlet]="kt_menu_item_inner"
              [ngTemplateOutletContext]="{ item: item, parentItem: parentItem, depth: (depth + 1) }">
            </ng-container>
          </a>
        }
      }
      <!-- if menu item has submenu child then recursively call new menu item component -->
      @if (item.items.length && !isDesktop) {
        <div class="{{ getSubmenuCssClasses(item, parentItem, depth) }}">
          <span class="kt-menu__arrow" [ngClass]="{ 'kt-menu__arrow--adjust': !parentItem }"></span>
          @if (item.items.length) {
            <ul class="kt-menu__subnav">
              @for (child of item.items; track child) {
                <ng-container [ngTemplateOutlet]="kt_menu"
                  [ngTemplateOutletContext]="{ item: child, parentItem: item, depth: (depth + 1) }">
                </ng-container>
              }
            </ul>
          }
        </div>
      }
      @if (isTabMenuUsed && !parentItem && !item.items.length && !isDesktop) {
        <div class="kt-menu__submenu kt-menu__submenu--classic kt-menu__submenu--left"
          [ngClass]="{'kt-menu__submenu--tabs': isTabMenuUsed}">
          <span class="kt-menu__arrow" [ngClass]="{ 'kt-menu__arrow--adjust': !parentItem }"></span>
          <ul class="kt-menu__subnav">
            <ng-container [ngTemplateOutlet]="kt_menu"
              [ngTemplateOutletContext]="{ item: item, parentItem: item, depth: (depth + 1) }">
            </ng-container>
          </ul>
        </div>
      }
    </li>
  }
</ng-template>

<!-- item inner -->
<ng-template #kt_menu_item_inner let-item="item" let-parentItem="parentItem">
  <!-- if menu item has icon -->
  <!-- <i *ngIf="item.icon" class="kt-menu__link-icon" [ngClass]="item.icon"></i> -->

  <ng-container>
    <!-- <span class="kt-menu__item-here"></span> -->
    <!-- menu item title text -->
    <span class="kt-menu__link-text top-menu-span">
      {{item.name | localize}}
    </span>
  </ng-container>

</ng-template>
